import { Injectable } from '@angular/core';
import { DpCharPatternValidator, DpFieldCheckbox, DpFieldGroup, DpFieldNumber, DpFieldSelect, DpFieldText, DpFormPresetService, DpFormRow, DpSection, DpSectionForm, DpSectionIcon, DpValidationRegex } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { Constants } from 'src/app/constants/constants';

import { GeneralConfigSection } from '../general-config.model';

@Injectable({
    providedIn: 'root'
})
export class GeneralFormService {

    constructor(
        private readonly formPresetService: DpFormPresetService
    ) {}

    getSectionForm(): DpSectionForm {
        return new DpSectionForm({
            sections: [this.getGeneralSection(), this.getLogSection(), this.getEmailSection(), this.getSmsSection()],
            i18nPrefix: 'general.form',
            sectionIcon: new DpSectionIcon(faCog)
        });
    }

    private getGeneralSection(): DpSection {
        return new DpSection({
            name: GeneralConfigSection.General,
            rows: [
                new DpFormRow([
                    new DpFieldText({ name: Constants.CONF_GEN_WORKING_DIRECTORY, required: true, column: 3 }),
                    new DpFieldNumber({ name: Constants.CONF_GEN_BATCH_SIZE_DELETING_JOBS, required: true, min: 1 })
                ]),
                new DpFormRow([
                    new DpFieldGroup({
                        fields: [
                            new DpFieldNumber({ name: Constants.CONF_GEN_REFRESH_LAST_HOUR, required: true, min: 5, max: 9999 }),
                            new DpFieldText({ name: Constants.CONF_GEN_SECONDS, disabled: true })
                        ],
                        labelTooltip: 'general.form.refresh-last-hour.tooltip'
                    })
                ])
            ]
        });
    }

    private getLogSection(): DpSection {
        return new DpSection({
            name: GeneralConfigSection.Log,
            rows: [
                new DpFormRow([
                    new DpFieldSelect({
                        name: Constants.CONF_LOG_MODE,
                        options: [
                            { value: Constants.CONF_LOG_FILE, requiredFields: [Constants.CONF_LOG_FILENAME, Constants.CONF_LOG_MAX_BACKUP_FILES, Constants.CONF_LOG_MAX_SIZE, Constants.CONF_LOG_MAX_SIZE_UNITS] },
                            { value: Constants.CONF_LOG_TCP, requiredFields: [Constants.CONF_LOG_SERVER, Constants.CONF_LOG_PORT] },
                            { value: Constants.CONF_LOG_UDP, requiredFields: [Constants.CONF_LOG_SERVER, Constants.CONF_LOG_PORT] },
                            { value: Constants.CONF_LOG_CONSOLE }
                        ],
                        required: true
                    }),
                    new DpFieldSelect({
                        name: Constants.CONF_LOG_LEVEL,
                        options: [
                            { value: Constants.CONF_LOG_INFO },
                            { value: Constants.CONF_LOG_DEBUG },
                            { value: Constants.CONF_LOG_ERROR },
                            { value: Constants.CONF_LOG_WARNING },
                            { value: Constants.CONF_LOG_TRACE },
                            { value: Constants.CONF_LOG_ALL }
                        ],
                        required: true
                    })
                ]),
                new DpFormRow([
                    new DpFieldText({ name: Constants.CONF_LOG_FILENAME, required: true, column: 9 })
                ]),
                new DpFormRow([
                    new DpFieldNumber({ name: Constants.CONF_LOG_MAX_BACKUP_FILES, required: true, min: 0, max: 1000 }),
                    new DpFieldGroup({
                        fields: [
                            new DpFieldNumber({ name: Constants.CONF_LOG_MAX_SIZE, required: true, min: 1 }),
                            new DpFieldSelect({
                                name: Constants.CONF_LOG_MAX_SIZE_UNITS,
                                options: [
                                    { value: Constants.CONF_LOG_KB },
                                    { value: Constants.CONF_LOG_MB },
                                    { value: Constants.CONF_LOG_GB }
                                ],
                                required: true
                            })
                        ]
                    })
                ]),
                new DpFormRow([
                    new DpFieldText({ name: Constants.CONF_LOG_SERVER, required: true, column: 3 }),
                    new DpFieldNumber({ name: Constants.CONF_LOG_PORT, required: true, min: 1, max: 65535 })
                ]),
                new DpFormRow([
                    new DpFieldText({ name: Constants.CONF_LOG_CUSTOM_MESSAGE_FORMAT, required: false, column: 3 }),
                    new DpFieldText({ name: Constants.CONF_LOG_CUSTOM_DATE_FORMAT, required: false, column: 3 })
                ]),
                new DpFormRow([
                    new DpFieldCheckbox({ name: Constants.CONF_LOG_DELETE })
                ])
            ]
        });
    }

    private getEmailSection(): DpSection {

        const config = {
            name: GeneralConfigSection.Email
        };

        return this.formPresetService.initEmailGeneralSection(config);
        
    }

    private getSmsSection(): DpSection {
        return new DpSection({
            name: GeneralConfigSection.Sms,
            rows: [
                new DpFormRow([
                    new DpFieldText({
                        name: Constants.CONF_SMS_PHONE_NUMBER, required: false, column: 3, validators: [
                            new DpCharPatternValidator({ pattern: DpValidationRegex.char.phoneNumber })
                        ]
                    }),
                    new DpFieldText({ name: Constants.CONF_SMS_ACCOUNT, required: false, column: 3 })
                ]),
                new DpFormRow([
                    new DpFieldText({ name: Constants.CONF_SMS_TOKEN, required: false, column: 3 })
                ])
            ]
        });
    }

}